import { Box, Heading, Image, ScrollView, Text, View } from "native-base";
import React, { useState, useRef, useEffect, useCallback } from "react";
import createStyles from "./styles";
import Input from "../../../../components/Input";
import { useTheme } from "../../../../ThemeProvider";
import Api from "../../../../Api/Api";
import { useNavigation, useRoute } from "@react-navigation/native";
import {
  DadosBasicos,
  DadosComplementares,
  DadosPagamento,
  Header,
  NavigationButtons,
} from "./components";
import Alerta from "../../../components/Alerta/Index";
import {
  validateDadosBasicos,
  validateDadosComplementares,
  validateDadosPagamento,
  DadosBasicos as DadosBasicosType,
  DadosComplementares as DadosComplementaresType,
  DadosPagamento as DadosPagamentoType,
  extrairHashDaURL,
  validarHash,
  extrairCodTransacaohDaURL,
} from "./utils";
import { usePreencherDados } from "./hooks";
import Loader from "../../../../components/Loader";
import { pagamentoOnlineService } from "./services";
import ModalConfirmacao from "../../../../components/ModalConfirmacao";
import PagamentoPix from "./components/PagamentoPix";
import {
  StyleSheet,
  Text as RNText,
  View as RNView,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import TemplateEtapas from "../../../template/Etapas/Index";
import { CORES, sombraCard } from "../../../template/Etapas/styles";
import { corComAlpha } from "../../../theme/cores";

const formatarTelefone = (tel: string): string => {
  let d = (tel || "").replace(/\D/g, "");
  if (d.length === 13 && d.startsWith("55")) d = d.slice(2);
  if (d.length === 12 && d.startsWith("55")) d = d.slice(2);
  if (d.length === 11)
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10)
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return tel;
};

const PagamentoOnline: React.FC = () => {
  const { primaryColor, getCodEmpresa, configEmpresa } = useTheme();

  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa as string),
  );

  const backgroundColor = getConfigEmpresa.coresPWA.corFundo;

  const styles = createStyles(getConfigEmpresa.coresPWA);
  const route = useRoute();
  const dados_empresa =
    (route.params as { dados_empresa?: any })?.dados_empresa || {};

  // Estado para controlar a etapa atual
  const [etapaAtual, setEtapaAtual] = useState<
    "basicos" | "complemento" | "pagamento" | "alterar-cartao" | "pix"
  >("basicos");

  // Estados para dados básicos
  const [nome, setNome] = useState<string>("");
  const [telefone, setTelefone] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [cpf, setCpf] = useState<string>("");
  const [dataNascimento, setDataNascimento] = useState<string>("");
  const [formaPagamento, setFormaPagamento] = useState<string>("");

  // Estados para dados de complemento
  const [cep, setCep] = useState<string>("");
  const [endereco, setEndereco] = useState<string>("");
  const [numero, setNumero] = useState<string>("");
  const [estado, setEstado] = useState<string>("");
  const [cidade, setCidade] = useState<string>("");
  const [bairro, setBairro] = useState<string>("");
  const [hashUrl, setHashUrl] = useState<string | null>(null);

  // Estados para dados de pagamento
  const [nomeCartao, setNomeCartao] = useState<string>("");
  const [numeroCartao, setNumeroCartao] = useState<string>("");
  const [validadeCartao, setValidadeCartao] = useState<string>("");
  const [cvv, setCvv] = useState<string>("");
  const [etapaCartao, setEtapaCartao] = useState<
    "numero-cartao" | "nome-cartao" | "validade-cartao" | "cvv"
  >("numero-cartao");

  // Estados para controle de alertas
  const [showErrorAlert, setShowErrorAlert] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loadingToken, setLoadingToken] = useState<boolean>(false);

  const navigation = useNavigation();
  const confirmationRef = useRef<any>(null);
  const importarRef = useRef<any>(null);
  const skipCpfCheck = useRef<boolean>(false);
  const lastCheckedCpf = useRef<string>("");
  const [dadosImportar, setDadosImportar] = useState<any>(null);
  const [dadosImportados, setDadosImportados] = useState<boolean>(false);
  const [loadingCpf, setLoadingCpf] = useState<boolean>(false);

  // Estados para o modal de confirmação
  const [codSeguranca, setCodSeguranca] = useState<string>("");
  // layout: guarda as funções Voltar/Próximo/Finalizar do DadosPagamento
  // para o "‹" do topo e o botão do rodapé chamarem as mesmas funções
  const acoesCartaoRef = useRef<any>(null);
  // Hook para preenchimento automático
  const {
    isLoading: isLoadingDados,
    error: errorDados,
    dados: dadosPreenchimento,
    buscarDados,
  } = usePreencherDados();

  // Função para limpar alertas de erro
  const clearErrorAlert = () => {
    setShowErrorAlert(false);
    setErrorMessage("");
  };

  // Função para preencher campos com dados da API
  const preencherCampos = () => {
    if (dadosPreenchimento) {
      // Dados básicos
      if (dadosPreenchimento.cliente) {
        if (dadosPreenchimento.cliente.nome)
          setNome(dadosPreenchimento.cliente.nome);
        if (dadosPreenchimento.cliente.telefone)
          setTelefone(formatarTelefone(dadosPreenchimento.cliente.telefone));
        if (dadosPreenchimento.cliente.email)
          setEmail(dadosPreenchimento.cliente.email);
        if (dadosPreenchimento.cliente.cpf_cnpj) {
          skipCpfCheck.current = true;
          setCpf(dadosPreenchimento.cliente.cpf_cnpj);
        }
        if (dadosPreenchimento.cliente.dataNascimento) {
          const dataNascimento =
            dadosPreenchimento.cliente.dataNascimento.split("-");
          const dia = dataNascimento[2];
          const mes = dataNascimento[1];
          const ano = dataNascimento[0];
          setDataNascimento(`${dia}/${mes}/${ano}`);
        }
      }

      if (dadosPreenchimento.cliente) {
        if (dadosPreenchimento.cliente.enderecocliente) {
          if (dadosPreenchimento.cliente.enderecocliente.cep)
            setCep(dadosPreenchimento.cliente.enderecocliente.cep);
          if (dadosPreenchimento.cliente.enderecocliente.endereco)
            setEndereco(dadosPreenchimento.cliente.enderecocliente.endereco);
          if (dadosPreenchimento.cliente.enderecocliente.numero)
            setNumero(dadosPreenchimento.cliente.enderecocliente.numero);
          if (dadosPreenchimento.cliente.enderecocliente.bairro)
            setBairro(dadosPreenchimento.cliente.enderecocliente.bairro);
          if (dadosPreenchimento.cliente.enderecocliente.cidade)
            setCidade(dadosPreenchimento.cliente.enderecocliente.cidade.id);
          if (dadosPreenchimento.cliente.enderecocliente.estado)
            setEstado(dadosPreenchimento.cliente.enderecocliente.estado.id);
          //   setCidade(dadosPreenchimento.cliente.clienteEndereco.cidade);
        }
      }

      if (dadosPreenchimento.status === "AGUARDANDO_ALTERACAO_CARTAO_LINK") {
        setEtapaAtual("alterar-cartao");
      }
      // TODO: REMOVER O CONSOLE.LOG APÓS TESTES
      // setEtapaAtual("pix");
      setFormaPagamento(dadosPreenchimento.formaPagamento || "");
      if (
        dadosPreenchimento.formaPagamento === "pix" &&
        (dadosPreenchimento.statusUltimaFatura === "AGUARDANDO_PAGAMENTO" ||
          dadosPreenchimento.statusUltimaFatura === "PAGO")
      ) {
        setEtapaAtual("pix");
      }
      //   setNome(dadosPreenchimento.cliente.nome);
      //   setTelefone(dadosPreenchimento.cliente.telefone);
      //   setEmail(dadosPreenchimento.cliente.email);
      //   setCpf(dadosPreenchimento.cliente.cpf);
      //           setDataNascimento(dadosPreenchimento.cliente.dataNascimento);
      // }

      //   // Dados complementares
      //   if (dadosPreenchimento.cep) setCep(dadosPreenchimento.cep);
      //   if (dadosPreenchimento.endereco) setEndereco(dadosPreenchimento.endereco);
      //   if (dadosPreenchimento.numero) setNumero(dadosPreenchimento.numero);
      //   if (dadosPreenchimento.bairro) setBairro(dadosPreenchimento.bairro);
      //   if (dadosPreenchimento.cidade) setCidade(dadosPreenchimento.cidade);
      //   if (dadosPreenchimento.estado) setEstado(dadosPreenchimento.estado);

      //   // Dados de pagamento
      //   if (dadosPreenchimento.nomeCartao)
      //     setNomeCartao(dadosPreenchimento.nomeCartao);
      //   if (dadosPreenchimento.numeroCartao)
      //     setNumeroCartao(dadosPreenchimento.numeroCartao);
      //   if (dadosPreenchimento.validadeCartao)
      //     setValidadeCartao(dadosPreenchimento.validadeCartao);
      //   if (dadosPreenchimento.cvv) setCvv(dadosPreenchimento.cvv);
    }
  };

  // Effect para buscar dados automaticamente ao carregar a tela
  useEffect(() => {
    const hash = extrairHashDaURL();

    if (hash && validarHash(hash)) {
      buscarDados(hash);
      setHashUrl(hash);
    } else {
      setHashUrl(null);
    }
  }, []);

  // Effect para preencher campos quando dados chegarem
  useEffect(() => {
    if (dadosPreenchimento) {
      preencherCampos();
    }
  }, [dadosPreenchimento]);

  const importarDadosPagamento = useCallback(() => {
    if (!dadosImportar) return;
    if (dadosImportar.nome) setNome(dadosImportar.nome);
    if (dadosImportar.email) setEmail(dadosImportar.email);
    if (dadosImportar.telefone)
      setTelefone(formatarTelefone(dadosImportar.telefone));
    setDadosImportados(true);
    if (dadosImportar.endereco) {
      const end = dadosImportar.endereco;
      if (end.cep) setCep(end.cep);
      if (end.endereco) setEndereco(end.endereco);
      if (end.numero) setNumero(end.numero);
      if (end.bairro) setBairro(end.bairro);
      if (end.cidade?.id) setCidade(end.cidade.id);
      if (end.estado?.id) setEstado(end.estado.id);
    }
    importarRef.current?.fecharModal();
  }, [dadosImportar]);

  // Effect para verificar CPF ao digitar
  useEffect(() => {
    const digits = (cpf || "").replace(/\D/g, "");
    if (skipCpfCheck.current) {
      skipCpfCheck.current = false;
      lastCheckedCpf.current = digits;
      return;
    }
    setDadosImportados(false);
    if (digits.length !== 11 || digits === lastCheckedCpf.current) return;
    lastCheckedCpf.current = digits;
    setLoadingCpf(true);
    pagamentoOnlineService
      .verificarCadastroPagamento(cpf, hashUrl ?? undefined)
      .then((res) => {
        if (res.existe) {
          setDadosImportar(res.dados ?? null);
          importarRef.current?.abrirModal();
        } else if (res.dadosOriginais) {
          const d = res.dadosOriginais;
          setNome(d.nome);
          setEmail(d.email);
          setTelefone(formatarTelefone(d.telefone));
          setCep("");
          setEndereco("");
          setNumero("");
          setBairro("");
          setCidade("");
          setEstado("");
        }
      })
      .catch(() => {})
      .finally(() => setLoadingCpf(false));
  }, [cpf]);

  // Funções de navegação
  const handleNext = () => {
    // navigation.navigate("ComprovantePtgOnline", {
    //   dados: {
    //     nome,
    //     telefone,
    //     email,
    //     cpf,
    //     dataNascimento,
    //   },
    // });

    // return;
    clearErrorAlert(); // Limpa alertas anteriores

    switch (etapaAtual) {
      case "basicos": {
        const dadosBasicos: DadosBasicosType = {
          nome,
          telefone,
          email,
          cpf,
          dataNascimento,
        };
        const result = validateDadosBasicos(dadosBasicos);
        if (result.isValid) {
          if (formaPagamento === "pix") {
            setEtapaAtual("pix");
            return;
          } else {
            setEtapaAtual("complemento");
          }
        } else {
          setErrorMessage(result.errorMessage || "Erro de validação");
          setShowErrorAlert(true);
        }
        break;
      }
      case "complemento": {
        const dadosComplementares: DadosComplementaresType = {
          cep,
          endereco,
          numero,
          bairro,
          cidade,
          estado,
        };
        const result = validateDadosComplementares(dadosComplementares);
        if (result.isValid) {
          setEtapaAtual("pagamento");
        } else {
          setErrorMessage(result.errorMessage || "Erro de validação");
          setShowErrorAlert(true);
        }
        break;
      }
    }
  };

  const handleBack = () => {
    switch (etapaAtual) {
      case "complemento":
        setEtapaAtual("basicos");
        break;
      case "pagamento":
        setEtapaAtual("complemento");
        break;
    }
  };

  // Função para processar o pagamento após confirmação
  const processarPagamento = async (dadosModal?: any) => {
    clearErrorAlert(); // Limpa alertas anteriores

    const dadosPagamento: DadosPagamentoType = {
      nomeCartao,
      numeroCartao,
      validadeCartao,
      cvv,
    };

    const result = validateDadosPagamento(dadosPagamento);
    if (result.isValid) {
      try {
        setLoadingToken(true);
        // Preparar dados para geração do token
        const [mes, ano] = validadeCartao.split("/");
        const payload = {
          type: "card",
          card: {
            number: numeroCartao.replace(/\s/g, ""), // Remove espaços
            holder_name: nomeCartao,
            exp_month: parseInt(mes),
            exp_year: parseInt(ano),
            cvv: cvv,
            amount: 10000,
          },
        };

        // Gerar token do cartão
        const tokenResult =
          await pagamentoOnlineService.gerarTokenCartao(payload);

        if (tokenResult.status && tokenResult.token) {
          // Token gerado com sucesso

          // Montar dados para finalizar cadastro
          const dadosFinalizacao = {
            dadosBasicos: {
              nome,
              telefone,
              email,
              cpf,
              dataNascimento,
            },
            dadosComplementares: {
              cep,
              endereco,
              numero,
              bairro,
              cidade,
              estado,
            },
            tokenCartao: tokenResult.token,
            codTransacao: dadosModal?.codSeguranca || "",
            hash: hashUrl,
          };

          try {
            // Finalizar cadastro
            const resultado = await Api.finalizarCadastro(dadosFinalizacao);

            if (resultado.status && resultado.data && resultado.data.status) {
              if (!resultado?.data?.status) {
                setErrorMessage(
                  (resultado?.data?.data?.mensagem as any) ||
                    "Erro ao finalizar cadastro",
                );
                setShowErrorAlert(true);
                return;
              }

              (navigation as any).navigate("ComprovantePtgOnline", {
                dados: {
                  ...resultado?.data?.data,
                },
              });
            } else {
              setNomeCartao("");
              setNumeroCartao("");
              setValidadeCartao("");
              setCvv("");
              setEtapaCartao("numero-cartao");
              setErrorMessage(
                resultado?.error_details?.message ||
                  resultado.error_message ||
                  "Erro ao finalizar cadastro",
              );
              setShowErrorAlert(true);
              //vamos limpar os dados do cartão
            }
          } catch (error) {
            console.error("Erro ao finalizar cadastro:", error);
            setErrorMessage("Erro inesperado ao finalizar cadastro");
            setShowErrorAlert(true);
          }
        } else {
          // Erro na geração do token
          const mensagemErro = tokenResult.erros
            ? tokenResult.erros.join(", ")
            : "Erro ao gerar token do cartão";
          setErrorMessage(mensagemErro);
          setShowErrorAlert(true);
        }
      } catch (error) {
        console.log("error....1 ", error);
        console.error("Erro ao gerar token:", error);
        setErrorMessage("Erro inesperado ao processar pagamento");
        setShowErrorAlert(true);
      } finally {
        setLoadingToken(false);
      }
    } else {
      setErrorMessage(result.errorMessage || "Erro de validação");
      setShowErrorAlert(true);
    }
  };

  const handleFinish = async () => {
    clearErrorAlert(); // Limpa alertas anteriores

    const dadosPagamento: DadosPagamentoType = {
      nomeCartao,
      numeroCartao,
      validadeCartao,
      cvv,
    };

    const result = validateDadosPagamento(dadosPagamento);
    if (result.isValid) {
      const codTransac = extrairCodTransacaohDaURL();

      if (codTransac && validarHash(codTransac)) {
        processarPagamento({
          codSeguranca: codTransac,
        });
        return;
      }

      confirmationRef.current.abrirModal();
    } else {
      setErrorMessage(result.errorMessage || "Erro de validação");
      setShowErrorAlert(true);
    }
  };

  const setAlertMessage = (message: string) => {
    console.log("message ", message);
    setErrorMessage(message);
    setShowErrorAlert(true);
  };

  // Função para obter mensagem do alerta
  const getAlertMessage = () => {
    switch (etapaAtual) {
      case "basicos":
        return "Preencha os dados básicos para continuar";
      case "complemento":
        return "Preencha os dados complementares para continuar";
      case "pagamento":
        return "Preencha os dados de pagamento para continuar";
      case "alterar-cartao":
        return "Informe os dados do novo cartão para continuar";
      default:
        return "Preencha todos os campos para continuar";
    }
  };

  // ---------------- Somente apresentação (layout novo) ----------------
  // Nada abaixo altera estado ou fluxo: só define textos e números exibidos.
  const corPrincipalLayout: string = primaryColor || "#006400";
  const fluxoPix = dadosPreenchimento?.formaPagamento === "pix";
  const totalEtapasLayout = fluxoPix ? 2 : 3;
  const numeroEtapaLayout: Record<string, number | undefined> = {
    basicos: 1,
    complemento: 2,
    pagamento: 3,
    pix: 2,
  };
  const etapaLayout = numeroEtapaLayout[etapaAtual];

  const textosEtapa: Record<string, { titulo: string; subtitulo?: string }> = {
    basicos: {
      titulo: "Seus dados",
      subtitulo: "Usados para emitir a cobrança.",
    },
    complemento: {
      titulo: "Endereço de cobrança",
      subtitulo: "Digite o CEP e completamos o resto.",
    },
    pagamento: { titulo: "Dados do cartão" },
    "alterar-cartao": {
      titulo: "Novo cartão",
      subtitulo: "Informe os dados do novo cartão para continuar.",
    },
    pix: {
      titulo: "Pague com Pix",
      subtitulo:
        "Abra o app do seu banco e escaneie o código, ou copie e cole.",
    },
  };
  const textoEtapaAtual = errorDados
    ? { titulo: "Pagamento" }
    : textosEtapa[etapaAtual];

  // resumo do plano: vem no retorno do /preencher-pagamento (name, valor,
  // intervalCobranca, intervalCountCobranca). Só aparece se vier nome e valor.
  const nomePlanoLayout =
    (dadosPreenchimento as any)?.name ??
    (dadosPreenchimento as any)?.descricao;
  const valorPlanoLayout = (dadosPreenchimento as any)?.valor;
  const periodoPlanoLayout = (() => {
    const intervalo = String(
      (dadosPreenchimento as any)?.intervalCobranca || "",
    ).toUpperCase();
    const quantidade = Number(
      (dadosPreenchimento as any)?.intervalCountCobranca || 1,
    );
    const nomes: Record<string, [string, string]> = {
      DAY: ["dia", "dias"],
      WEEK: ["semana", "semanas"],
      MONTH: ["mês", "meses"],
      YEAR: ["ano", "anos"],
    };
    if (!nomes[intervalo]) return "";
    return quantidade > 1
      ? `a cada ${quantidade} ${nomes[intervalo][1]}`
      : `por ${nomes[intervalo][0]}`;
  })();

  const etapaCartaoLayout =
    etapaAtual === "pagamento" || etapaAtual === "alterar-cartao";

  // basicos/complemento: mesmas condições do antigo NavigationButtons.
  // cartão: os botões Voltar/Próximo/Finalizar ficavam sempre visíveis dentro
  // do DadosPagamento; agora a moldura chama as mesmas funções (acoesCartaoRef).
  const exibeRodapeLayout = etapaCartaoLayout
    ? !errorDados
    : !errorDados &&
      !loadingToken &&
      etapaAtual !== "pix";

  const textoBotaoLayout = (() => {
    if (etapaAtual === "basicos" && fluxoPix) return "Gerar Pix";
    if (etapaCartaoLayout && etapaCartao === "cvv") {
      if (etapaAtual === "alterar-cartao") return "Finalizar";
      return valorPlanoLayout != null
        ? `Pagar ${Number(valorPlanoLayout || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })}`
        : "Finalizar pagamento";
    }
    return "Continuar";
  })();

  // no "alterar cartão", o Voltar da 1ª parte não fazia nada: não exibe o "‹"
  const ocultarVoltarLayout = etapaCartaoLayout
    ? etapaAtual === "alterar-cartao" && etapaCartao === "numero-cartao"
    : etapaAtual !== "complemento";

  const renderErroLayout = (mensagem: string) => (
    <RNView style={stylesLayout.caixaErro}>
      <Feather name="alert-circle" size={16} color="#C0392B" />
      <RNText style={stylesLayout.textoErro}>{mensagem}</RNText>
    </RNView>
  );

  return (
    <TemplateEtapas
      rotuloEtapa={
        etapaAtual === "alterar-cartao"
          ? "Alterar cartão"
          : fluxoPix
            ? "Pagamento"
            : "Pagamento com cartão"
      }
      contadorEtapa={
        etapaLayout && !errorDados ? `${etapaLayout}/${totalEtapasLayout}` : ""
      }
      etapaAtual={!errorDados ? etapaLayout : undefined}
      totalEtapas={!errorDados ? totalEtapasLayout : undefined}
      titulo={textoEtapaAtual?.titulo ?? ""}
      subtitulo={textoEtapaAtual?.subtitulo}
      conteudoTopo={
        <>
          {/* no cartão o erro aparece embaixo do campo atual */}
          {showErrorAlert &&
            !etapaCartaoLayout &&
            renderErroLayout(errorMessage)}
          {errorDados && renderErroLayout(errorDados)}
        </>
      }
      ocultarFechar
      ocultarVoltar={ocultarVoltarLayout}
      onVoltarClick={() =>
        etapaCartaoLayout ? acoesCartaoRef.current?.voltar() : handleBack()
      }
      ocultarRodape={!exibeRodapeLayout}
      avisoRodape="Pagamento seguro e criptografado"
      textoBotao={textoBotaoLayout}
      iconeBotao={
        etapaCartaoLayout && etapaCartao === "cvv" ? "check" : "arrow-right"
      }
      onBotaoClick={() =>
        etapaCartaoLayout ? acoesCartaoRef.current?.proximo() : handleNext()
      }
    >
      <Box style={styles.mainContainer}>
        {etapaAtual === "basicos" &&
          !errorDados &&
          !!nomePlanoLayout &&
          valorPlanoLayout != null && (
            <RNView style={[stylesLayout.cardPlano, sombraCard]}>
              <RNView
                style={[
                  stylesLayout.iconePlano,
                  { backgroundColor: corComAlpha(corPrincipalLayout, 0.1) },
                ]}
              >
                <Feather
                  name="package"
                  size={17}
                  color={corPrincipalLayout}
                />
              </RNView>
              <RNView style={{ flex: 1 }}>
                <RNText style={stylesLayout.rotuloPlano}>
                  Plano de assinatura
                </RNText>
                <RNText style={stylesLayout.nomePlano}>
                  {String(nomePlanoLayout)}
                </RNText>
              </RNView>
              <RNView style={{ alignItems: "flex-end" }}>
                <RNText style={stylesLayout.valorPlano}>
                  {Number(valorPlanoLayout || 0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </RNText>
                {!!periodoPlanoLayout && (
                  <RNText style={stylesLayout.periodoPlano}>
                    {periodoPlanoLayout}
                  </RNText>
                )}
              </RNView>
            </RNView>
          )}

        {etapaAtual === "basicos" && !errorDados ? (
          <DadosBasicos
            getConfigEmpresa={getConfigEmpresa}
            nome={nome}
            setNome={setNome}
            telefone={telefone}
            setTelefone={setTelefone}
            email={email}
            setEmail={setEmail}
            cpf={cpf}
            setCpf={setCpf}
            dataNascimento={dataNascimento}
            setDataNascimento={setDataNascimento}
            dadosImportados={dadosImportados}
          />
        ) : etapaAtual === "complemento" && !errorDados ? (
          <DadosComplementares
            getConfigEmpresa={getConfigEmpresa}
            cep={cep}
            setCep={setCep}
            endereco={endereco}
            setEndereco={setEndereco}
            numero={numero}
            setNumero={setNumero}
            bairro={bairro}
            setBairro={setBairro}
            cidade={cidade}
            setCidade={setCidade}
            estado={estado}
            setEstado={setEstado}
          />
        ) : (etapaAtual === "pagamento" || etapaAtual === "alterar-cartao") &&
          !errorDados ? (
          <DadosPagamento
            getConfigEmpresa={getConfigEmpresa}
            nomeCartao={nomeCartao}
            setNomeCartao={setNomeCartao}
            numeroCartao={numeroCartao}
            setNumeroCartao={setNumeroCartao}
            validadeCartao={validadeCartao}
            setValidadeCartao={setValidadeCartao}
            cvv={cvv}
            setCvv={setCvv}
            etapaCartao={etapaCartao}
            setEtapaCartao={(value: string) => setEtapaCartao(value as any)}
            onBack={handleBack}
            onFinish={handleFinish}
            primaryColor={primaryColor}
            acoesRef={acoesCartaoRef}
            mensagemErro={showErrorAlert ? errorMessage : undefined}
          />
        ) : etapaAtual === "pix" && !errorDados ? (
          <PagamentoPix
            getConfigEmpresa={getConfigEmpresa}
            nome={nome}
            telefone={telefone}
            email={email}
            cpf={cpf}
            dataNascimento={dataNascimento}
            hashUrl={hashUrl || ""}
            setAlertMessage={setAlertMessage}
            nomePlano={nomePlanoLayout ? String(nomePlanoLayout) : undefined}
          />
        ) : null}
      </Box>

      {(isLoadingDados || loadingToken || loadingCpf) && <Loader />}

      <ModalConfirmacao
        ref={importarRef}
        titulo={"Cadastro encontrado"}
        mensagem={
          "Este CPF já possui um cadastro de pagamento. Deseja importar os dados?"
        }
        textoBotaoNegativo={"Não"}
        textoBotaoPositivo={"Sim, importar"}
        onConfirmNegativo={() => {
          importarRef.current?.fecharModal();
          setCpf("");
        }}
        onConfirmPositivo={() => {
          importarDadosPagamento();
        }}
      />

      <ModalConfirmacao
        ref={confirmationRef}
        titulo={"Atenção"}
        mensagem={"Informe o código de transação!"}
        textoBotaoNegativo={"Cancelar"}
        textoBotaoPositivo={"Confirmar"}
        onConfirmNegativo={() => {
          confirmationRef.current?.fecharModal();
        }}
        onConfirmPositivo={(dados) => {
          confirmationRef.current?.fecharModal();
          console.log("dados ", dados);
          if (dados.codSeguranca.trim() === "") {
            setErrorMessage("Código de transação é obrigatório");
            setShowErrorAlert(true);
            return;
          }

          processarPagamento(dados);
        }}
        capturarDados={() => {
          return {
            codSeguranca: codSeguranca,
          };
        }}
      >
        <Box style={{ marginTop: 10 }}>
          <Input
            placeholder="Código de transação"
            value={codSeguranca}
            width="100%"
            onChangeText={setCodSeguranca}
          />
        </Box>
      </ModalConfirmacao>
    </TemplateEtapas>
  );
};

const stylesLayout = StyleSheet.create({
  caixaErro: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 8,
    marginTop: 14,
    padding: 12,
    borderRadius: 12,
    backgroundColor: "#FBE6E3",
  },
  textoErro: {
    flex: 1,
    fontSize: 13,
    lineHeight: 18,
    color: "#9B2C20",
    fontWeight: "600",
  },
  cardPlano: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    padding: 14,
    marginBottom: 16,
    borderRadius: 16,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
  },
  iconePlano: {
    width: 36,
    height: 36,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  rotuloPlano: {
    fontSize: 11,
    color: CORES.subtitulo,
  },
  nomePlano: {
    fontSize: 15,
    fontWeight: "700",
    color: CORES.titulo,
  },
  valorPlano: {
    fontSize: 15,
    fontWeight: "800",
    color: CORES.titulo,
  },
  periodoPlano: {
    fontSize: 11,
    color: CORES.subtitulo,
  },
});

export default PagamentoOnline;
